export default {
  title: {
    text: null
  },
  tooltip: {
    crosshairs: true,
    shared: true
  },
  xAxis: {
    type: 'datetime',
    title: {
      text: 'Date'
    }
  },
  yAxis: [
    {
      title: {
        text: 'kW'
      }
    }
  ],
  chart: {
    type: 'line',
    zoomType: 'x',
    events: {}
  },
  plotOptions: {
    series: {
      connectNulls: false,
      animation: false
    },
    line: {
      turboThreshold: 0,
      marker: {
        enabled: false
        // radius: 1
      }
    },
    column: {
      turboThreshold: 0,
      stacking: 'normal'
    },
    area: {
      turboThreshold: 0,
      stacking: 'normal',
      marker: {
        enabled: false
      }
    },
    threshold: 0,
    turboThreshold: 0
  },
  series: []
};



// WEBPACK FOOTER //
// ./src/helper/chartConfig.js